import Blob from 'blob';


const labels = [
  {
    name: 'S.No',
    value: 'index',
  },
  {
    name: 'Name',
    value: 'name',
  },
  {
    name: 'College',
    value: 'college',
  },
  {
    name: 'University',
    value: 'university',
  },
  {
    name: 'Roll No',
    value: 'rollNo',
  },
  {
    name: 'Gender',
    value: 'gender',
  },
  {
    name: 'Date of Birth',
    value: 'dob',
  },
  {
    name: '10th Marks',
    value: 'marks10Board',
  },
  {
    name: 'Year of Passing',
    value: 'yop10Board',
  },
  {
    name: '12th Marks',
    value: 'marks12Board',
  },
  {
    name: 'Year of Passing',
    value: 'yop12Board',
  },
  {
    name: 'Graduation Agg Marks',
    value: 'marksGraduation',
  },
  {
    name: 'Year of Passing',
    value: 'yopGraduation',
  },
  {
    name: 'Branch',
    value: 'stream',
  },
  {
    name: 'Degree',
    value: 'degree',
  },
  {
    name: 'Backlogs',
    value: 'backlogs',
  },
  {
    name: 'Placement Status',
    value: 'placed',
  },
  {
    name: 'Certifications',
    value: 'certifications',
  },
  {
    name: 'Email',
    value: 'email',
  },
  {
    name: 'Mobile',
    value: 'contact',
  },
];

const csvConverter = (JSONData, fileName = 'Registrations') => {
  const arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;
  let csv = '';
  let row = '';
  labels.forEach((fieldName) => {
    row += `${fieldName.name},`;
  });
  row = row.slice(0, -1);
  csv += `${row}\r\n`;

  for (let i = 0; i < arrData.length; i += 1) {
    row = '';
    const arrRow = arrData[i];
    // eslint-disable-next-line
    labels.forEach((fieldName) => {
      const { value } = fieldName;
      if (value === 'index') {
        row += `${i + 1},`;
      } else {
        const arrValue = typeof arrRow[value] === 'undefined' ? '' : `"${arrRow[value]}"`;
        row += `${arrValue},`;
      }
    });
    row.slice(0, row.length - 1);
    csv += `${row}\r\n`;
  }

  if (csv === '') {
    return;
  }

  // const uri = `data:application/csv;charset=utf-8,${escape(csv)}`;
  const uri = new Blob([csv], { type: 'text/csv' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(uri);
  link.style = 'visibility:hidden';
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default csvConverter;



// WEBPACK FOOTER //
// ./src/utils/csvConverter.js